import { createFileRoute } from "@tanstack/react-router";
import SevenSecretsGuide from "@/pages/site/SevenSecretsGuide";

export const Route = createFileRoute("/resources/7-secrets-guide")({
  component: () => <SevenSecretsGuide />,
});
